export function getUrlDomain(url) {
  var _domain$;

  var urlReg = /(http?:\/\/|https:\/\/|\/\/)?([^\/\?#]+)/i;
  var domain = url.match(urlReg);
  return (_domain$ = domain === null || domain === void 0 ? void 0 : domain[2]) !== null && _domain$ !== void 0 ? _domain$ : '';
}